import React from "react";
import { Button, Modal } from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleNotch} from "@fortawesome/fontawesome-free-solid";

/**
 *
 * @param {{show: boolean, onHide: Function, title: Object, dialogApiError: Object, body: Object, noFooter: boolean, leftButtonText: Object, leftButtonVariant: string, leftButtonDisabled: boolean, rightButtonText: Object, rightButtonVariant: string, rightButtonDisabled: boolean, rightButtonCallback: Function, leftButtonCallback: Function, ref: Ref}} props
 */
const BaseDialog = (props) => {
  return (<Modal
    show={props.show}
    onHide={props.onHide}
    onKeyUp={props.onKeyUp}
    size={props.size || "lg"}
    aria-labelledby="contained-modal-title-vcenter"
    centered
    ref={props.innerRef} >
    <Modal.Header closeButton>
      <Modal.Title id="contained-modal-title-vcenter">
        {props.title}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {props.dialogApiError}
      {props.body}
    </Modal.Body>
    {!props.noFooter && <Modal.Footer>
      {props.leftButtonText &&
      <Button
        className={`btn btn-${props.leftButtonVariant}`}
        onClick={props.leftButtonCallback}
        disabled={props.leftButtonDisabled}
        >
        {props.leftButtonText}
      </Button>}
      {props.rightButtonText ? (props.rightButtonIsLoading ? (<Button
          className={`btn btn-${props.rightButtonVariant}`}
          disabled={true}
          onClick={props.rightButtonCallback}
      >
        <FontAwesomeIcon icon={faCircleNotch} spin /> {props.rightButtonText}
      </Button>) : (<Button
          className={`btn btn-${props.rightButtonVariant}`}
          disabled={props.rightButtonDisabled}
          onClick={props.rightButtonCallback}
      >
        {props.rightButtonText}
      </Button>)) : "" }
    </Modal.Footer>}
  </Modal>);
}

export default BaseDialog;
